import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error.response?.status === 401) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});

export default queryClient;
